(() => {
  class AspadzPickRide extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.retryTimer = null;
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      window.clearTimeout(this.retryTimer);

      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    init() {
      if (this.swiper) return;

      if (typeof window.AspadzConceptCarousel === 'undefined') {
        this.retryTimer = window.setTimeout(() => this.init(), 120);
        return;
      }

      const slider = this.querySelector('[data-aspadz-pick-ride-slider]');
      const slides = this.querySelectorAll('.aspadz-pick-ride__slide');
      if (!slider || slides.length < 2) return;

      this.swiper = new window.AspadzConceptCarousel(slider, {
        autoplay: false,
        centeredSlides: false,
        initialSlide: 0,
        loop: false,
        navigation: {
          nextEl: this.querySelector('[data-aspadz-pick-ride-next]'),
          prevEl: this.querySelector('[data-aspadz-pick-ride-prev]'),
        },
        pagination: {
          clickable: true,
          el: this.querySelector('[data-aspadz-pick-ride-pagination]'),
          renderBullet(index, className) {
            return `
              <button class="${className}" type="button" aria-label="Go to slide ${index + 1}">
                <span class="aspadz-pick-ride__pagination-track">
                </span>
              </button>
            `;
          },
        },
        slidesPerView: 'auto',
        spaceBetween: 16,
        speed: 650,
        watchOverflow: true,
        breakpoints: {
          750: {
            slidesOffsetBefore: () => Math.max(24, (document.documentElement.clientWidth - 1540) / 2),
            spaceBetween: 20,
          },
        },
      });
    }
  }

  if (!window.customElements.get('aspadz-pick-ride')) {
    window.customElements.define('aspadz-pick-ride', AspadzPickRide);
  }
})();
